'use client';

import { organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const coreApiUrl = import.meta.env.VITE_CORE_API_URL;

export const authClient = createAuthClient({
  baseURL: coreApiUrl,
  basePath: '/auth',
  // organization.setActive scopes the OAuth consent token to the chosen org.
  plugins: [organizationClient()],
});

// Only used for Google OAuth redirect
export const { signIn } = authClient;
